import axios from 'axios'
import apiConfiguration from '../utilities/api/apiConfiguration'
import 'url-search-params-polyfill'
import generateUuid from '../utilities/api/generateUuid'

import moment from 'moment'
import setCookie from '../utilities/session/setCookie'

export const FETCH_SPECIAL_CODE_BEGIN   = 'FETCH_SPECIAL_CODE_BEGIN'
export const FETCH_SPECIAL_CODE_SUCCESS = 'FETCH_SPECIAL_CODE_SUCCESS'
export const FETCH_SPECIAL_CODE_FAILURE = 'FETCH_SPECIAL_CODE_FAILURE'

export const fetchSpecialCodeBegin = () => ({
	type: FETCH_SPECIAL_CODE_BEGIN
})

export const fetchSpecialCodeSuccess = availability => ({
	type: FETCH_SPECIAL_CODE_SUCCESS,
	payload: availability
})

export const fetchSpecialCodeError = error => ({
	type: FETCH_SPECIAL_CODE_FAILURE,
	payload: { error }
})

// Handle initial config request
export default function ValidateSpecialCode(rateQuery) {
	return (dispatch) => {
		let currentLanguage = 'en'
		let sessionId = generateUuid()

		let clientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			clientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		const fetchQuery = new URLSearchParams()

		let urlParams = {
			adults: 1,
			children: 0,
			clientId: clientId,
			endDate: moment(rateQuery.endDate).format('YYYY-MM-DD'),
			hotelCode: rateQuery.hotelCode,
			hotelProvider: rateQuery.hotelProvider,
			primaryLangId: currentLanguage,
			promoCode: rateQuery.promoCode,
			sessionId: sessionId,
			startDate: moment(rateQuery.startDate).format('YYYY-MM-DD'),
		}

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		let apiBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/avail-rooms?'
		const fetchResult = apiBase + fetchQuery.toString()

		dispatch(fetchSpecialCodeBegin())
		return axios.get(fetchResult, apiConfiguration())
			.then((response) => {
				// Narrow results to hydra member see OTA spec for details
				const availability = response.data['hydra:member'].map(avail => {
					return avail
				})

				setCookie('flowSessionId', sessionId, 1)
				dispatch(fetchSpecialCodeSuccess(availability))

				return availability
			})
			.catch(error => dispatch(fetchSpecialCodeError(error)))
	}
}


// WEBPACK FOOTER //
// ./src/actions/validateSpecialCode.js